import React from 'react'
import './footer.css'
import {FaCopyright} from 'react-icons/fa'

const Footer = () => {
  return (
        <div id="Footer">
          No <FaCopyright/> copyright issues
        </div>
  )
}

export default Footer